// extracted by css-extract-rspack-plugin
export default {"container":"IndexDetailsDialog-module__container___X8m0","header":"IndexDetailsDialog-module__header__QUEH5","headerSubtext":"IndexDetailsDialog-module__headerSubtext__hmWJo"};